export default {
  name: 'TwinTableIconColumn',
  props: {
    data: {
      type: String,
      required: false,
      default: null
    }
  }
};